import { FactoryProvider, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  errorMessagesEnFactory,
  MinError,
  NGX_MAT_ERROR_CONFIG_EN,
  NGX_MAT_ERROR_DEFAULT_OPTIONS
} from 'ngx-mat-errors';

export const NGX_MAT_ERROR_DEFAULT_CONFIG: FactoryProvider = {
  useFactory: (locale: string) => ({
    ...errorMessagesEnFactory(locale),
    message: (error: string ) => error,
  }),
  provide: NGX_MAT_ERROR_DEFAULT_OPTIONS,
  deps: [LOCALE_ID],
};

@NgModule({
  providers: [
    NGX_MAT_ERROR_CONFIG_EN,
    NGX_MAT_ERROR_DEFAULT_CONFIG
  ]
})
export class ValidatorModule { }
